import { render, staticRenderFns } from "./TypesTab.vue?vue&type=template&id=0597d7dd&scoped=true"
import script from "./TypesTab.vue?vue&type=script&lang=js"
export * from "./TypesTab.vue?vue&type=script&lang=js"
import style0 from "./TypesTab.vue?vue&type=style&index=0&id=0597d7dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597d7dd",
  null
  
)

export default component.exports